import { LinkOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useParams, Link } from "react-router";

import PageModalNavigation from "@/components/Elements/PageModalNavigation";
import ObservationModalContent from "@/components/Observation/ObservationModalContent";
import { getObservationTitle, useGetObservation } from "@/entities/observation";
import ModelFavoriteButton from "@/modules/model-favorite-button";
import ObservationBreadcrumb from "@/modules/observation/observation-breadcrumb";
import PageModal from "@/modules/page-modal";
import { StateEditForm } from "@/modules/state-edit-form";

const ObservationDetails = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const { observation = {}, isLoading } = useGetObservation(id);
  const observationHasData = observation.id ? true : false;
  const { source_intervention } = observation;

  return (
    <PageModal
      keyboard
      mask={{ closable: true }}
      title={getObservationTitle(observation)}
      beforeTitle={
        <PageModalNavigation
          model="observation"
          itemId={id}
          formatTitle={getObservationTitle}
        />
      }
      afterTitle={
        <Tooltip title={t("observation:sourceObservationLink")}>
          <Link
            data-testid="link-to-observation"
            aria-label={t("observation:sourceObservationLink")}
            to={`/interventions/${source_intervention?.id}?observation_id=${id}`}
          >
            <LinkOutlined />
          </Link>
        </Tooltip>
      }
      loading={isLoading}
      className="observation-modal"
      breadcrumb={
        observationHasData && (
          <ObservationBreadcrumb observation={observation} />
        )
      }
      headerActions={[
        <StateEditForm
          key="state-edit"
          stateType="observation"
          model={observation}
        />,
        <ModelFavoriteButton
          key="favorite"
          loading={isLoading}
          modelKey="observation"
          item={observation}
          style={{ height: 32 }}
        />,
      ]}
    >
      {observationHasData && (
        <ObservationModalContent observation={observation} />
      )}
    </PageModal>
  );
};

export default ObservationDetails;
